import { useTranslation } from "react-i18next";
import { Box, Divider, Text } from "@hawkins/components";
import { Dimensions } from "@hawkins/variables";

import { Page } from "../Page";
import { StatusBanner } from "../StatusBanner";
import { TranslationNamespace } from "../../types";
import { EmergencyRequestCTA } from "../EmergencyRequestCTA";

export default function Submitted() {
  const { t } = useTranslation(TranslationNamespace.LEP);

  return (
    <Page>
      <Box
        display="grid"
        gridTemplateColumns={"1fr"}
        placeItems="flex-start"
        rowGap={Dimensions.Space16}
      >
        <StatusBanner
          text={t('account_request_submitted')}
          variant="success"
        />

        <Text bold gutterTop={Dimensions.Space6}>
          {t('account_request_received')}
        </Text>

        <Text gutterTop={Dimensions.Space4}>
          {t('account_request_instructions')}
        </Text>

        <Divider
          style={{
            marginTop: Dimensions.Space8,
            marginBottom: Dimensions.Space6,
          }}
        />

        <EmergencyRequestCTA />
      </Box>
    </Page>
  );
};
